import { render } from "./FileViewer.vue?vue&type=template&id=014576a0&scoped=true&ts=true"
import script from "./FileViewer.vue?vue&type=script&lang=ts"
export * from "./FileViewer.vue?vue&type=script&lang=ts"

import "./FileViewer.vue?vue&type=style&index=0&id=014576a0&lang=scss&scoped=true"
import "./FileViewer.vue?vue&type=style&index=1&id=014576a0&lang=scss"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-014576a0"]])

export default __exports__